import React from "react";
import api from "../../lib/api";
import { CalendarRange, TrendingUp, UserPlus, Mail } from "lucide-react";

export default function AdminDashboard() {
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    api.get("/admin/dashboard").then(r => setData(r.data));
  }, []);

  if (!data) return <div className="text-text-cream/40">Chargement…</div>;

  const cards = [
    { icon: CalendarRange, label: "Sessions à venir", value: data.upcoming_sessions, suffix: "" },
    { icon: TrendingUp, label: "Revenus du mois", value: data.revenue_month_chf, suffix: "CHF" },
    { icon: UserPlus, label: "Nouvelles inscriptions (7j)", value: data.new_registrations_week, suffix: "" },
    { icon: Mail, label: "Messages non lus", value: data.unread_messages, suffix: "" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow mb-4">Vue d'ensemble</div>
      <h1 className="h-display text-4xl md:text-5xl">Tableau de bord.</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
        {cards.map((c) => (
          <div key={c.label} className="border border-white/10 p-6" data-testid={`stat-${c.label}`}>
            <c.icon size={20} className="text-accent-deep" strokeWidth={1.5}/>
            <div className="eyebrow mt-4 text-text-cream/50">{c.label}</div>
            <div className="font-serif text-4xl mt-2">
              {c.value}<span className="text-base text-text-cream/40 ml-1 font-sans">{c.suffix}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
